import TagManager from "react-gtm-module"

export const findParentCategory = (categories, id) => {
  for (const parent of categories) {
    if (parent.id === id) return parent?.title
    if (parent.children && parent.children.length > 0) {
      for (const child of parent.children) {
        if (child.id === id) return parent?.title
        if (child.children && child.children.length > 0) {
          for (const grandchild of child.children) {
            if (grandchild.id === id) return parent?.title
          }
        }
      }
    }
  }
  // If not found at this level, check deeper recursively
  for (const parent of categories) {
    if (parent.children && parent.children.length > 0) {
      const found = findParentCategory(parent.children, id)
      if (found) return found?.title
    }
  }
  return null
}

export function toSnakeCase(str) {
  return str
    ?.replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/[A-Z]/g, (letter) => letter.toLowerCase()) // Lowercase all letters
    .toLowerCase()
}

function productMapper(product, type) {
  let returnData = {
    item_id: product.product_id || product.id || product?.sku_code,
    item_name: product.title,
    affiliation: "Nagarey Website",
    currency: "IDR",
    discount:
      product?.discount_coupon ||
      (product.price - product.sell_price > 0
        ? product.price - product.sell_price
        : 0), // 'without quotation mark',
    index: product.index || 1, // 'increase for each item in list',
    item_brand: "Nagarey",
    item_category: product.firstcategory?.title || "",
    item_category2: product.secondcategory?.title || "",
    item_list_id: toSnakeCase(product.listName || "All Products"), // if no id use item list name in snake case format.
    item_list_name: product.listName || "All Products",
    item_variant: "None",
    price: product.sell_price || product?.price, // 'without quotation mark & plain number without 1000 separator',
    quantity: product.quantity || 1, // 'without quotation mark'
  }
  if (type !== 1) {
    delete returnData.item_list_id // Remove item_list_id for types other than 1
    delete returnData.item_list_name // Remove item_list_name for types other than 1
  }
  return returnData
}

export const sendDataLayer = async (sendData, clearPrev) => {
  if (TagManager?.dataLayer) {
    if (clearPrev) {
      TagManager.dataLayer({
        dataLayer: { ecommerce: null }, // Clear the previous ecommerce object.
      })
    }
    TagManager.dataLayer({
      dataLayer: {
        ...sendData,
      },
    })
  }
}

export const sendDatalayerNavigationMenu = (contentName) =>
  sendDataLayer({
    event: "navigation_menu",
    content_name: contentName,
    section: "Navigation Menu",
  })

export const sendDatalayerSearch = (searchTerm) =>
  sendDataLayer({
    event: "search",
    search_term: searchTerm,
  })

export const sendDatalayerFooter = (contentName, type) => {
  function eventType() {
    switch (type) {
      case "contact":
        return "contact_us"
      case "menu":
        return "footer_menu"
      case "social":
        return "social_media_click"
      default:
        return "footer"
    }
  }
  return sendDataLayer({
    event: eventType(),
    content_name: contentName,
    section: "Footer",
  })
}

export const sendDatalayerPromo = ({ promo, type, isMobile }) => {
  function eventType() {
    switch (type) {
      case "view":
        return "view_promotion"
      case "select":
        return "select_promotion"
      default:
        return ""
    }
  }
  return sendDataLayer(
    {
      event: eventType(),
      ecommerce: {
        creative_name: isMobile ? promo?.mobile : promo?.desktop,
        creative_slot: promo?.slot,
        promotion_id: promo?.id || toSnakeCase(promo?.title),
        promotion_name: promo?.title,
      },
    },
    true
  )
}

export const sendDatalayerProduct = ({ event, data, type = 1 }) => {
  const listName = data?.listName || "All Products"
  const type1 = {
    item_list_id: toSnakeCase(listName), //if no id use item list name in snake case format. ,
    item_list_name: listName,
  }
  const type2 = {
    currency: "IDR",
    value: data?.sell_price, //'without quotation mark & plain number without 1000 separator',
  }
  const type3 = {
    curreny: "IDR",
    value: data?.grand_total,
  }
  return sendDataLayer(
    {
      event,
      ecommerce: {
        ...(type === 1
          ? { ...type1 }
          : type === 2
          ? { ...type2 }
          : { ...type3 }),
        items:
          type === 3
            ? data?.items?.map((item) => productMapper(item, type))
            : [productMapper(data, type)],
      },
    },
    true
  )
}

export const sendDatalayerCheckout = ({ event, data }) => {
  function type() {
    switch (event) {
      case "purchase":
        return {
          shipping_tier:
            data?.shipping?.shipping_method || "Nagarey Courier Service",
          payment_type: data?.payment_method,
          transaction_id: data?.order_no,
          tax: data?.tax || 0,
        }
      case "add_shipping_info":
        return {
          shipping_tier: data?.shipping,
        }
      case "add_payment_info":
        return {
          payment_type: data?.payment_type,
        }
      default:
        return {}
    }
  }
  return sendDataLayer(
    {
      event,
      ecommerce: {
        currency: "IDR",
        value: data?.grand_total || data?.total_amount, //'without quotation mark & plain number without 1000 separator'
        coupon: data?.applied_codes?.length
          ? data?.applied_codes?.toString()
          : "None",
        ...type(),
        items: data?.items?.map((item) => productMapper(item, 0)),
      },
    },
    true
  )
}
